import { createSelector } from 'reselect';
export const getBulkActionsState = (state) => state.bulkActions;
export const getBulkActionsIsModalOpen = (state) => getBulkActionsState(state).isModalOpen;
export const getBulkActionsData = (state) => getBulkActionsState(state).actionsData;
export const getSelectedActions = (state) => getBulkActionsState(state).selectedActionKeys;
export const getUnselectedActions = createSelector(getBulkActionsData, getSelectedActions, (data, selectedActions) => Object.keys(data).filter((key) => !selectedActions.includes(key)));
export const getSelectedTagsToAdd = createSelector(getBulkActionsData, (actions) => actions.addTag.tags);
export const getSelectedTagNamesToAdd = createSelector(getSelectedTagsToAdd, (tags) => tags.map((tag) => tag.name));
export const getSelectedTagsToRemove = createSelector(getBulkActionsData, (actions) => actions.removeTag.tags);
export const getSelectedTagNamesToRemove = createSelector(getSelectedTagsToRemove, (tags) => tags.map((tag) => tag.name));
export const getReplyMessage = (state) => {
    return getBulkActionsData(state).sendReply;
};
export const getInternalNote = (state) => {
    return getBulkActionsData(state).addInternalNote.note;
};
export const getSelectedQueue = (state) => {
    return getBulkActionsData(state).transferToQueue.queue;
};
export const getBulkConversationIDs = (state) => {
    return getBulkActionsState(state).conversationIDs;
};
export const getBulkActionsLocation = (state) => getBulkActionsState(state).meta.location;
